import React, { useEffect, useState } from "react";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Input,
  InputGroup,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import ChannelForm from "../component/ChannelForm";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ChannelInsituteForm from "../../ChannelPartnerInstitute/component/ChannelInstituteForm";
import Select from "react-select";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import DestinationService from "../../../services/KangarooServices/DestinationService";
import toast from "react-hot-toast";
import noimage from "../../../assets/kangaroo/noimage.png";

const tabs = ["Assigned Partner"];

const ChannelPartner = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Assigned Partner");
  const [unassignData, setUnassignData] = useState();
  console.log("🚀 ~ ChannelPartner ~ unassignData:", unassignData);
  const [mediaGroup, setMediaGroup] = useState([]);
  const [filters, setFilters] = useState({
    destinationCountry: "",
  });
  const [isUnassign, setIsUnassign] = useState(false);
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);
    return () => clearTimeout(timer);
  }, [filters]);
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };
  const toggleAssignModal = (item) => {
    setSelectedItem(item);
    setIsAssignModalOpen(!isAssignModalOpen);
  };
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const fetchGroup = async () => {
    try {
      const response = await DestinationService.getList();
      setMediaGroup(response);
    } catch (error) {
      console.error("Error fetching categories:", error);
      toast.error("Failed to fetch categories");
    }
  };
  useEffect(() => {
    fetchGroup();
  }, []);
  const fetchData = async () => {
    try {
      const response = await ChannelService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchUnassignedData = async () => {
    try {
      const response = await ChannelService.getUnassignList(
        debouncedFilters.destinationCountry || "", // pass label or empty string
      );
      setUnassignData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    fetchUnassignedData();
  }, [debouncedFilters]);
  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        if (activeTab === "Assigned Partner") {
          await ChannelService.delete(selectedDeleteItem.id);
        } else {
          await UniversityService.delete(selectedDeleteItem.universityId);
        }
        fetchData();
        fetchUnassignedData();
        toast.success("Selected Item deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const mediaGroupOptions = mediaGroup.map((group) => ({
    label: group.name,
    value: group.slug,
  }));
  const handleMediaGroupChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      destinationCountry: selectedOption ? selectedOption.value : null,
    }));
  };
  const filteredData = data.filter(
    (item) =>
      item.name?.toLowerCase().includes(search.toLowerCase()) ||
      item.destinationCountryName?.toLowerCase().includes(search.toLowerCase()),
  );
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Channel Partners" pageTitle="Content Management" />
        <Nav tabs className="mb-3">
          {tabs.map((t) => (
            <NavItem key={t}>
              <NavLink
                className={activeTab === t ? "active" : ""}
                onClick={() => setActiveTab(t)}
                style={{ cursor: "pointer" }}
              >
                {t}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeTab}>
          {/* BASIC */}
          <TabPane tabId="Assigned Partner">
            <Row className="mb-3">
              <Col lg={6}>
                <div className="d-flex justify-content-between align-items-center ">
                  <button className="btn btn-success" onClick={toggleModal}>
                    <i className="bi bi-plus-lg"></i> New Partner
                  </button>
                </div>
              </Col>
              <Col lg={6}>
                <InputGroup>
                  <Input
                    placeholder="Search by channel partner's name and university name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row xs="1" md="2" lg="4" className="g-3">
              {filteredData?.map((item, index) => {
                return (
                  <Col lg={4} key={item.id}>
                    <Card className="h-100 shadow-sm border-0 rounded-4 small-card">
                      <div className="logo-wrapper">
                        {item?.isUnassignedPartner === false ? (
                          <CardImg
                            top
                            // src={`${imageBaseApi}${item?.logo?.url}`}
                            src={
                              item?.logo?.url
                                ? `${imageBaseApi}${item.logo.url}`
                                : noimage
                            }
                            alt={item.fileName}
                            style={{
                              objectFit: "contain",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        ) : (
                          <div className="bg-light h-100 d-flex justify-content-center align-content-center align-items-center">
                            <h3 className="font-bold">Unassigned Partner</h3>
                          </div>
                        )}
                      </div>
                      <CardBody className="py-2 px-3">
                        <p>{item?.name}</p>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          {item?.universities?.slice(0, 4).map((uni, index) => (
                            <img
                              key={index}
                              src={`${imageBaseApi}${uni?.logo?.url}`}
                              className="avatar-sm object-fit-contain"
                              alt="university-logo"
                            />
                          ))}

                          {item?.universities?.length > 5 && (
                            <div
                              className="avatar-sm d-flex align-items-center justify-content-center bg-light text-primary fw-semibold cursor-pointer"
                              onClick={() =>
                                navigate(`/channel-partners/detail/${item.id}`)
                              }
                            >
                              +{item.universities.length - 5}
                            </div>
                          )}
                        </div>
                      </CardBody>
                      <CardFooter className="bg-transparent border-0 pt-0 pb-3 px-3">
                        <div className="d-flex justify-content-between ">
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              color="info"
                              className="d-flex align-items-center gap-1"
                              onClick={() =>
                                navigate(`/channel-partners/detail/${item?.id}`)
                              }
                            >
                              <i className="bx bx-show" />
                            </Button>
                            <Button
                              size="sm"
                              color="warning"
                              className="d-flex align-items-center gap-1"
                              onClick={() => toggleModal(item)}
                            >
                              <i className="ri-edit-line"></i>
                            </Button>
                            <Button
                              size="sm"
                              color="danger"
                              className="d-flex align-items-center gap-1"
                              onClick={() => handleDeleteClick(item)}
                            >
                              <i className="ri-delete-bin-5-line"></i>
                            </Button>
                          </div>

                          {/* <Button
                            size="sm"
                            color="warning"
                            className="d-flex align-items-center gap-1"
                            onClick={() => toggleAssignModal(item)}
                          >
                            Assign institute
                          </Button> */}
                          <div className="d-flex gap-2">
                            <Button
                              size="sm"
                              color="warning"
                              onClick={() =>
                                navigate(`/assign-institute/${item.id}`)
                              }
                            >
                              Institute
                            </Button>
                            <Button
                              size="sm"
                              color="info"
                              onClick={() =>
                                navigate(`/reorder-institute/${item.id}`)
                              }
                            >
                              Reorder institute
                            </Button>
                          </div>
                        </div>
                      </CardFooter>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </TabPane>
          <TabPane tabId="Unassigned Partner">
            <Row className="mb-3">
              <div className="d-flex justify-content-between align-items-center ">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    navigate(`/unassign-partner`);
                  }}
                  //  onClick={toggleAssignModal}
                >
                  <i className="bi bi-plus-lg"></i> Assign Institute
                </button>
                <div>
                  <Select
                    options={mediaGroupOptions}
                    value={mediaGroupOptions.find(
                      (option) => option.value === filters.slug,
                    )}
                    onChange={handleMediaGroupChange}
                    placeholder="Select destination country"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div>
            </Row>
            <Row>
              {unassignData?.universities?.map((item, index) => (
                <Col lg={3} key={item.universityId}>
                  <Card>
                    <div style={{ height: "25vh", overflow: "hidden" }}>
                      <CardImg
                        top
                        src={`${imageBaseApi}${item?.universityLogoUrl?.url}`}
                        alt={item.fileName}
                        className=" object-fit-cover"
                      />
                    </div>
                    <CardBody>
                      <p>{item.universityName}</p>
                    </CardBody>

                    <CardFooter>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex gap-2">
                          {/* <Button
                            size="sm"
                            color="info"
                            onClick={() =>
                              navigate(
                                `/channel-partners/detail/${item.universityId}`,
                              )
                            }
                          >
                            <i className="bx bx-show" />
                          </Button> */}

                          {/* <Button
                            size="sm"
                            color="warning"
                            onClick={() => toggleModal(item)}
                          >
                            <i className="ri-edit-line"></i>
                          </Button> */}

                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => handleDeleteClick(item)}
                          >
                            <i className="ri-delete-bin-5-line"></i>
                          </Button>
                        </div>

                        {/* <Button
                          size="sm"
                          color="warning"
                          onClick={() => toggleAssignModal(item)}
                        >
                          Assign institute
                        </Button> */}
                      </div>
                    </CardFooter>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
        </TabContent>

        <ChannelForm
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
        <ChannelInsituteForm
          isOpen={isAssignModalOpen}
          toggle={toggleAssignModal}
          selectedItem={selectedItem}
          fetchData={fetchData}
          isUnassign={isUnassign}
          mediaGroup={mediaGroup}
          activeTab={activeTab}
        />
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default ChannelPartner;
